import { GetListParams, UpdateParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { listTokenConfigs, updateTokenConfig } from '../../../services/xpxPerpsChainTokenConfigService';

const resourceName = 'xpx-perps/chain-token-config/tokens';

export const xpxPerpsTokenConfigsDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};
    const chainId = params.filter?.chainId ? Number(params.filter.chainId) : undefined;
    const response = await listTokenConfigs(chainId, page, perPage);
    const items: any[] = response.data?.items ?? [];
    const total: number = response.data?.total ?? items.length;
    return {
      data: items.map((item) => ({ ...item, id: item.tokenAddress })),
      total,
    };
  },

  async update(_resource: string, params: UpdateParams): Promise<any> {
    const { data } = params;
    await updateTokenConfig(
      Number(data.chainId),
      data.tokenAddress,
      data.depositEnabled,
      data.withdrawalEnabled,
    );
    return { data: { ...data, id: data.tokenAddress } };
  },
};

registerModuleDataProvider(resourceName, xpxPerpsTokenConfigsDataProvider);
